import styled from 'styled-components'

const StyledReferences = styled.div`
  font-size: 80%;
  margin: 1.5rem auto;
  max-width: 75ch;
  padding: 1.5rem;

  h2 {
    font-weight: 400;
    margin: 0;
  }

  ul {
    margin-top: 0;

    li {
      margin-bottom: 0.25rem;
      margin-top: 0.25rem;
    }
  }
`

export default StyledReferences
